import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { modeTone } from '../pages/time/timeData'

const PREVIEW = 8

/** "B - Office" -> "Office": the leading code is for the server, not the reader. */
export function modeName(mode: string): string {
  return mode.replace(/^[A-Za-z] - /, '')
}

function ModeGroup({ mode, people }: { mode: string; people: string[] }) {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)
  const overflow = people.length - PREVIEW
  const shown = expanded ? people : people.slice(0, PREVIEW)
  return (
    <li className="space-y-1.5">
      <div className="flex items-center gap-2">
        <span className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${modeTone(mode)}`}>
          {modeName(mode)}
        </span>
        <span className="text-xs tabular-nums text-slate-500 dark:text-slate-400">{people.length}</span>
      </div>
      <ul className="m-0 flex list-none flex-wrap gap-1 p-0">
        {shown.map((name) => (
          <li
            key={name}
            className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-600 dark:bg-slate-700/60 dark:text-slate-300"
          >
            {name}
          </li>
        ))}
        {overflow > 0 && (
          <li>
            <button
              type="button"
              onClick={() => setExpanded((open) => !open)}
              aria-expanded={expanded}
              className="cursor-pointer rounded-full px-2 py-0.5 text-xs text-blue-700 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus dark:text-blue-400"
            >
              {expanded ? t('hr.showLess') : `+${overflow}`}
            </button>
          </li>
        )}
      </ul>
    </li>
  )
}

/** A person with no Plan or Actual row for today is in no group; the server does not invent an "unknown" bucket, and neither does this. */
export function WorkModeToday({ groups }: { groups: { mode: string; people: string[] }[] }) {
  const { t } = useTranslation()
  return (
    <figure className="viz-root m-0 rounded-xl border border-l-4 border-slate-200 border-l-violet-400 bg-white p-4 dark:border-slate-700 dark:border-l-violet-500 dark:bg-slate-800">
      <figcaption className="mb-3">
        <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-100">
          {t('dashboard.workModeNow')}
        </h3>
      </figcaption>
      {groups.length === 0 ? (
        <p className="text-xs text-slate-500 dark:text-slate-400">{t('dashboard.noData')}</p>
      ) : (
        <ul className="m-0 flex list-none flex-col gap-3 p-0">
          {groups.map((group) => (
            <ModeGroup key={group.mode} mode={group.mode} people={group.people} />
          ))}
        </ul>
      )}
    </figure>
  )
}
